<a>
    <span ng-bind-html="match.model.orgUnitName | uibTypeaheadHighlight:query"></span>
    <span class="second-column">{{match.model.orgUnitPath}}</span>
</a>
